import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { EpaStatus } from '@shared/models/data-model';
import { RegistrationService } from '@shared/services/registration.service';

export const epaStatusResolver: ResolveFn<EpaStatus> = (route, state) => {
    return inject(RegistrationService).getEpaStatus();
};
